import { memo, useMemo } from 'react';

import { useBlueConicInteraction } from '../hooks/useBlueConicInteraction';
import { useBlueConicValues } from '../hooks/useBlueConicValues';
import { useTeamInterestOptions } from '../store';

import TeamInRound from './TeamInRound';

import { useUser } from '@hooks/useUser';

const TeamInterest = () => {
  const { options } = useTeamInterestOptions();
  const { interactionRaised } = useBlueConicInteraction(options.variantId);
  const properties = useMemo(
    () => (interactionRaised ? [options.teamInterestProperty] : []),
    [options.teamInterestProperty, interactionRaised],
  );
  const { logged, isLoading } = useUser();

  const { values } = useBlueConicValues(properties);
  const teamInterestId = useMemo(() => values[options?.teamInterestProperty], [options?.teamInterestProperty, values]);
  const roundId = useMemo(() => options.roundId, [options.roundId]);

  if (isLoading || !teamInterestId || !roundId) return null;

  return <TeamInRound roundId={roundId} teamInterestId={teamInterestId} logged={logged} />;
};

export default memo(TeamInterest);
